var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33675 8.27262L1.08675 2.02262C0.910632 1.8465 0.811689 1.60763 0.811689 1.35856C0.811689 1.10949 0.910632 0.870617 1.08675 0.694496C1.26287 0.518376 1.50174 0.419433 1.75082 0.419433C1.99989 0.419433 2.23876 0.518376 2.41488 0.694497L8.00003 6.28122L13.5868 0.69606C13.674 0.608854 13.7775 0.539678 13.8914 0.492483C14.0054 0.445287 14.1275 0.420996 14.2508 0.420996C14.3741 0.420996 14.4963 0.445287 14.6102 0.492483C14.7241 0.539678 14.8277 0.608854 14.9149 0.69606C15.0021 0.783266 15.0713 0.886794 15.1185 1.00073C15.1657 1.11467 15.1899 1.23679 15.1899 1.36012C15.1899 1.48345 15.1657 1.60557 15.1185 1.71951C15.0713 1.83345 15.0021 1.93698 14.9149 2.02418L8.66488 8.27418C8.57768 8.36148 8.4741 8.43071 8.36009 8.47789C8.24608 8.52507 8.12388 8.54929 8.00049 8.54914C7.8771 8.549 7.75496 8.5245 7.64106 8.47704C7.52716 8.42959 7.42375 8.36012 7.33675 8.27262Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/CollapseIcon.e90ed81ac0b5352b42970ee5d43d768a.svg";
export { ForwardRef as ReactComponent };